<template>
  <div>
    <div class="row">
      <div class="col-lg-3">
        <v-select placeholder="Status" :options="['assigned', 'completed', 'created', 'closed']" multiple v-model="filters['status']" @input="loadTasks"></v-select>
      </div>
      <div class="col-lg-3" v-if="user.admin">
        <v-select placeholder="Assignee" :options="f.users" label="username" index="id" multiple v-model="filters['assignee']" @input="loadTasks"></v-select>
      </div>
      <div class="col-lg-3">
        <v-select placeholder="Type" :options="['fix','content','build','tech']" multiple v-model="filters['type']" @input="loadTasks"></v-select>
      </div>
      <div class="col-lg-3">
        <v-select
          placeholder="Group"
          :options="order.filters.groups"
          label="name"
          index="id"
          v-model="filters['group']"
          @input="loadTasks"
          multiple
        ></v-select>
      </div>
    </div>
    <div class="row col-lg-12 m-t-sm" v-if="tasks.length">
      <h4>
        Showing {{ tasksMeta.count }} tasks
        <button class="btn btn-xs btn-primary pull-right" @click="loadTasks(true)"><i class="fa fa-file-csv"></i> Download Csv</button>
      </h4>
    </div>
    <table class="table table-hover m-t-sm">
      <thead>
      <tr>
        <th>Task</th>
        <th>Pbn</th>
        <th>Client</th>
        <th>Group</th>
        <th>Type</th>
        <th>Added</th>
        <th>By</th>
        <th>Assignee</th>
        <th>Status</th>
        <th>Updated</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="task in tasks" :key="task.id" :class="'task-' + task.status + (task.blocker ? ' task-blocked' : '')">
        <td>
          <span :class="'m-r-xs label label-' + (task.priority === 'low' ? 'default' : (task.priority === 'medium' ? 'info' : 'danger'))" :title="task.priority">
            <i class="fa fa-tasks"></i>
          </span>
          <i class="fa fa-ban red" v-if="task.blocker" :title="task.blocker.type + ' - ' + task.blocker.message" v-tooltip="task.blocker.type + ' - ' + task.blocker.message"></i>
          <router-link :to="'/maintenance/task/' + task.id">{{ task.title }}</router-link>
        </td>
        <td>{{ task.pbn.domain }}</td>
        <td>{{ task.pbn.client.name }}</td>
        <td>{{ task.pbn.group ? task.pbn.group.name : '/' }}</td>
        <td>{{ task.type }}</td>
        <td>{{ task.created | aTime('from') }}</td>
        <td>{{ task.creator | get('name') }}</td>
        <td>{{ task.assignee ? task.assignee.name : '/' }}</td>
        <td>{{ task.status }}</td>
        <td>
          <span v-if="task.updated && task.updated.date" :title="task.updated.date">
            {{ task.updated | aTime('from') }}
          </span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { Query, Browser } from '../../../../../mixins/helperMixin'

export default {
  data () {
    return {
      tasks: [],
      tasksMeta: {},
      filters: {}
    }
  },
  mounted () {
    this.loadTasks()
  },
  computed: {
    ...mapGetters({
      order: 'getMaintenanceOrder',
      f: 'getFilters',
      user: 'getUser'
    })
  },
  mixins: [Query],
  methods: {
    loadTasks (csv = false) {
      axios.get(`/maintenance/tasks?order=${this.$route.params.id}&` + this.buildQuery(this.filters), {
        headers: {
          Accept: csv === true ? 'text/csv' : 'application/json'
        }
      })
        .then(r => {
          if (csv === true) {
            Browser.methods.downloadFile('tasks.csv', r.data.data)
          } else {
            this.tasksMeta = r.data.meta
            this.tasks = r.data.data
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MaintenanceOrder/Order/Tabs/Tasks.vue